const authenticityLetter = (v, entity, name, props) => (props.isEdition ? v : null);

export default authenticityLetter;
